export function customTemplateSelection(data) {
  if (data.selected.length > 1) {
    var string = `${data.selected[0].text} et ${data.selected.length - 1} autre`;
    if (data.selected.length > 2) {
      string += 's'
    }
    return string;
  }
  else {
    return data.selected[0].text;
  }
}

export function customTemplateResult(state) {
  return $('<label class="form-check"><input class="form-check-input" id="checkbox' + state.id + '" type="checkbox" ' + (state.selected ? 'checked' : '') + '> ' + state.text + '</label>', { id: state.id });
}
